import { system_dropdown } from "../../service/system";

import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function FormDropdown(props) {
  const {
    className,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true },
    data: {
      name,
      options = [],
      optionLabel = "label",
      optionValue = "value",
      placeholder = "",
      filter = false,
      filterBy = "value",
      disabled = false,
      showClear = true,
      saveFun = () => {},
    },
  } = props;

  const onChange = (e, field) => {
    field.onChange(e.value === undefined ? null : e.value);

    saveFun({ name: e.target.name });

    if (isSubmitted) {
      trigger();
    } else {
      trigger(field.name);
    }
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Dropdown
            id={field.name}
            className={classNames(
              { "p-invalid": fieldState.invalid },
              "w-full",
              className
            )}
            {...field}
            value={field.value || field.value == 0 ? field.value : null}
            onChange={(e) => onChange(e, field)}
            disabled={!isEdit || disabled}
            placeholder={placeholder}
            options={options}
            optionLabel={optionLabel}
            optionValue={optionValue}
            emptyMessage={system_dropdown.empty}
            filter={filter}
            filterBy={filterBy}
            emptyFilterMessage={system_dropdown.emptyFilter}
            showClear={showClear}
          />
        )}
      />
    </>
  );
}
